/* eslint-disable react-hooks/exhaustive-deps */
// LanguageSelector.js
import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const LanguageSelector = () => {
  const { t, i18n } = useTranslation();

  // Define language mappings
  const languageConfig = {
    english: {
      flag: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.6/flags/4x3/ca.svg",
      displayName: () => t("henglish"),
    },
    french: {
      flag: "https://upload.wikimedia.org/wikipedia/commons/5/5f/Flag_of_Quebec.svg",
      displayName: () => t("hfrench"),
    },
  };

  const [selectedLanguage, setSelectedLanguage] = useState("english");
  const [flag, setFlag] = useState(languageConfig.english.flag);

  // Initialize language from localStorage on component mount
  useEffect(() => {
    const applicationLanguage = JSON.parse(
      localStorage.getItem("applicationLanguage") || '"english"'
    );

    // Normalize the language value
    let normalizedLang = "english"; // default
    if (applicationLanguage) {
      const lowerLang = applicationLanguage.toLowerCase();
      if (lowerLang === "french" || lowerLang === "francais") {
        normalizedLang = "french";
      } else if (lowerLang === "english" || lowerLang === "anglais") {
        normalizedLang = "english";
      }
    }

    // Set the language in i18n
    i18n.changeLanguage(normalizedLang);

    // Update state
    setSelectedLanguage(normalizedLang);
    setFlag(languageConfig[normalizedLang].flag);
  }, []); // Empty dependency array - only run on mount

  const handleSelect = (eventKey) => {
    // Use eventKey directly instead of trying to parse text content
    const language = eventKey;

    if (language && languageConfig[language]) {
      // Change language in i18n
      i18n.changeLanguage(language);

      // Store in localStorage
      localStorage.setItem("applicationLanguage", JSON.stringify(language));

      // Update state
      setSelectedLanguage(language);
      setFlag(languageConfig[language].flag);
    }
  };

  // Get display name for selected language
  const getDisplayName = (lang) => {
    return languageConfig[lang]?.displayName() || lang;
  };

  return (
    <DropdownButton
      id="dropdown-basic-button"
      title={
        <span>
          <img
            src={flag}
            alt={selectedLanguage}
            style={{ width: "20px", marginRight: "10px" }}
          />
          {getDisplayName(selectedLanguage)}
        </span>
      }
      variant="primary"
      className="mb-2"
      onSelect={handleSelect}
    >
      <Dropdown.Item eventKey="english">
        <span>
          <img
            src={languageConfig.english.flag}
            alt="English"
            style={{ width: "20px", marginRight: "10px" }}
          />
          {t("henglish")}
        </span>
      </Dropdown.Item>
      <Dropdown.Item eventKey="french">
        <span>
          <img
            src={languageConfig.french.flag}
            alt="French"
            style={{ width: "20px", marginRight: "10px" }}
          />
          {t("hfrench")}
        </span>
      </Dropdown.Item>
    </DropdownButton>
  );
};

export default LanguageSelector;
